<template>
	<div class="rank">
		<div class="navBox" v-if="showtab">
			<div :class="[index == active ? 'active' : '']" v-for="(item,index) in navList" @click="toggleNav(index)">{{ item.name }}</div>
		</div>
		<div class="navBox-none" v-else>
			
		</div>

		<div class="rankBox">
			<div class="img02">
				<img v-if="type == 1" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655871024-62b29630caa95.png" alt="">				
			</div>
			<div class="rankBox_tips">*本榜单数据每日实时更新</div>
			 <div class="rankBox-module" v-if="navList[active].type == 1 && alist.length != 0">
				<div class="rankBox-module-my" v-if="myData1 != ''">
					<div class="rankBox-module-my-img">
						<img v-if="myData1 != ''" :src="myData1.avatarurl" alt="">
					</div>
					<div class="rankBox-module-my-rank">
						<div class="myname1">{{ myData1 != '' ? myData1.nickname : '' }}</div>
						<div class="myname2">排名：第{{ myData1 != '' ? myData1.rank : '' }}位 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;得分：{{ myData1.total_score }}  分</div>
					</div>
				</div>
				<div class="rankBox-module-header">
					<div class="label01">排名</div>
					<div class="label02">用户名</div>
					<div class="label03">项目得分/个数</div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in alist" :key="index">
						<div class="item-01">
							<img v-if="index == 0" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f5b45f.png" alt="">
							<img v-else-if="index == 1" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f1f929.png" alt="">
							<img v-else-if="index == 2" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f3d793.png" alt="">
							<span v-else>{{ index + 1 }}</span>
						</div>
						<div class="item-02">
							<div class="item-02-img">
								<img :src="item.avatarurl" alt="">
							</div>
							<div class="item-02-txt">{{ item.nickname }}</div>
						</div>
						<div class="item-03">
							{{ item.total_score }}分
						</div>
					</div>
				</div>
			</div> 
			<div class="rankBox-module" v-if="navList[active].type == 2 && blist.length != 0">
				<div class="rankBox-module-my" v-if="myData2 != '' ">
					<!-- <div class="rankBox-module-my-img">
						<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20211208/1638953359-61b0718f7862c.png" alt="">
					</div> -->
					<div class="rankBox-module-my-rank">
						<div class="myname1">{{ myData2.nickname }}</div>
						<div class="myname2">排名：第{{ myData2.rank }}位 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;得分：{{ myData2.total_score }}  分</div>
					</div>
				</div>
				<div class="rankBox-module-header">
					<div class="label01">排名</div>
					<div class="label02">用户名</div>
					<div class="label03">项目得分/个数</div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in blist">
						<div class="item-01">
							<img v-if="index == 0" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f5b45f.png" alt="">
							<img v-else-if="index == 1" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f1f929.png" alt="">
							<img v-else-if="index == 2" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f3d793.png" alt="">
							<span v-else>{{ index+1 }}</span>
						</div>
						<div class="item-02">
							<!-- <div class="item-02-img">
								<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20211208/1638953359-61b0718f7862c.png" alt="">
							</div> -->
							<div class="item-02-txt">{{ item.nickname }}</div>
						</div>
						<div class="item-03">
							{{ item.total_score }}分
						</div>
					</div>
				</div>
			</div>
 			<div class="rankBox-module" v-if="navList[active].type == 3 && clist.length != 0">
				<div class="rankBox-module-my">
					<div class="rankBox-module-my-rank">
						<div class="myname1">我的排名</div>
						<div class="myname2">排名：第3位 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;得分：86  分</div>
					</div>
				</div>
				<div class="rankBox-module-header">
					<div class="label01">排名</div>
					<div class="label02">用户名</div>
					<div class="label03">项目打分</div>
				</div>
				<div class="list">
					<div class="item">
						<div class="item-01">
							<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f5b45f.png" alt="">
						</div>
						<div class="item-02">
							<div class="item-02-txt">韩梅梅</div>
						</div>
						<div class="item-03">
							90分
						</div>
					</div>
				</div>
			</div> 
			<div v-if="ismore" @click="getMore" class="moreClass" style="font-size: .24rem;border: 1px solid #eee;
	width: 2rem;
	margin: auto;
	text-align: center;
	padding: .1rem 0;
	margin-top: .2rem;">加载更多</div>
			
			
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			navList: [
				{
					name: '个人排行榜',
					type: 1,
				},{
					name: '企业排行榜',
					type: 2,
				},{
					name: '团队排行榜',
					type: 3,
				}
			],
			// navList: [
			// 	{
			// 		name: '个人排行榜',
			// 		type: 1,
			// 	},
			// 	{
			// 		name: '团队排行榜',
			// 		type: 3,
			// 	}
			// ],
			active: 0,
			
			
			activity_id: 0,
			page: 1,
			
			
			alist: [],
			myData1: '',
			blist: [],
			myData2: '',
			clist: [],
			myData3: '',
			
			urid: '',
			token: '',
			gid: '',
			ismore:true,
			type: 3,
			sports_item_id: '',
			showtab:0,
		}
	},
	mounted() {
		this.activity_id = this.$route.params.id
		this.type = this.$route.params.type
		this.sports_item_id = this.$route.params.sports_item_id ? this.$route.params.sports_item_id : ''
		
		
		if(this.type == 3){
			// this.navList.push({
			// 	name: '团队排行榜',
			// 	type: 3,
			// })
			// this.activity_id = 1056
			var { urid, token, gid } = JSON.parse(window.localStorage.getItem('movehealth/default/userInfo')) 
			// var token =
			this.urid = urid
			this.token = token
			this.gid = gid
			// console.log('urid', urid)
			var data = {
			
				page: this.page,
				sports_id: this.activity_id,
				type: this.navList[this.active].type
			}
			this.getRankData2(data)
		}else if(this.type == 2){
			var { urid, token, gid } = JSON.parse(window.localStorage.getItem('movehealth/default/userInfo'))
			// var token =
			this.urid = urid
			this.token = token
			this.gid = gid
			// console.log('urid', urid)
			var data = {
			
				page: this.page,
				sports_id: this.activity_id,
				type: this.navList[this.active].type
			}
			this.getRankData2(data)
		}else{
			// this.activity_id = 1056
			var { urid, token, gid } = JSON.parse(window.localStorage.getItem('movehealth/default/userInfo')) 
			// var token =
			this.urid = urid
			this.token = token
			this.gid = gid
			// console.log('urid', urid)
			var data = {
			
				page: this.page,
				activity_id: this.activity_id,
				type: this.navList[this.active].type
			}
			this.getRankData(data)
		}
		
	},
	methods: {
		toggleNav(idx){
			this.active = idx
			this.page = 1
			this.alist = []
			this.blist = []
			this.clist = []
			this.myData1 = ''
			this.myData2 = ''
			this.myData3 = ''
			
			if(this.type == 3){
				var data = {
				
					page: this.page,
					sports_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData2(data)
			}else if(this.type == 2){
				
				var data = {
				
					page: this.page,
					sports_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData2(data)
			}else{
				
				var data = {
				
					page: this.page,
					activity_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData(data)
			}
			
			
			
		},
		
		getRankData(data){
			data.gid = this.gid
			data.token = this.token
			data.urid = this.urid
			
			this.$api.answer
				.getRankData(data)
				.then((res) => {
					if(res.code == 200){
						
						if(this.navList[this.active].type == 1){
							this.myData1 = res.data.my == null ? '' : res.data.my
							console.log('myData1', this.myData1)
							// res.data.list = [1,1,1,1,1,1,1,1,1,1,11,1,1,1]
							this.alist = this.alist.concat(res.data.list) 
							this.showtab = res.data.register_type? res.data.register_type : 0;
							if(this.alist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}	
							console.log(this.alist,'11')
							
						}
						if(this.navList[this.active].type == 2){
							this.myData2 = res.data.my == null ? '' : res.data.my
							this.blist = this.blist.concat(res.data.list) 
							if(this.blist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
							console.log(this.blist,'this.blist')
						}
						if(this.navList[this.active].type == 3){
							this.myData3 = res.data.my  == null ? '' : res.data.my
							this.clist = this.clist.concat(res.data.list) 
							console.log(this.clist,'this.clist')
							if(this.clist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
						}
					}
				})
		},
		getMore(){
			this.page = this.page + 1
			if(this.type = 1){
				var data = {
				
					page: this.page,
					activity_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData(data)
			}else{
				var data = {
				
					page: this.page,
					sports_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData2(data)
			}
		},
		
		getRankData2(data){
			data.gid = this.gid
			data.token = this.token
			data.urid = this.urid
			data.sports_item_id = this.sports_item_id
			this.$api.answer
				.getRankData2(data)
				.then((res) => {
					if(res.code == 200){
						
						if(this.navList[this.active].type == 1){
							this.myData1 = res.data.my == null ? '' : res.data.my
							// res.data.list = [1,1,1,1,1,1,1,1,1,1,11,1,1,1]
							this.alist = this.alist.concat(res.data.list) 
							
							if(this.alist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
							
						}
						if(this.navList[this.active].type == 3){
							this.myData2 = res.data.my == null ? '' : res.data.my
							this.blist = this.blist.concat(res.data.list) 
							if(this.blist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
						}
						if(this.navList[this.active].type == 2){
							this.myData3 = res.data.my == null ? '' : res.data.my
							this.clist = this.clist.concat(res.data.list) 
							if(this.clist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
						}
					}
				})
		}
		
	}
}
</script>

<style lang="less" scoped>
@import './index.less';
.rank{
	background: #fdb77d;
	min-height: 100%;
	box-sizing: border-box;
	padding-bottom: .5rem;
}
</style>
